import { useMemo } from "react";
import { useSelector } from "react-redux";

export default function useUserStatus() {
    const user = useSelector((state) => state.auth?.user);

    const status = useMemo(() => {
        if (!user) {
            return null
        }

        const hasPanCard = Boolean(user?.verification?.pan_number);
        const hasPanVerified = Boolean(user?.verification?.pan_verified);

        const hasAadharCardVerified = Boolean(user?.verification?.aadhar_verified);

        const hasGstNumber = Boolean(user?.verification?.gst_number);
        const hasGstVerified = Boolean(user?.verification?.gst_verified);

        // const hasTaxInvoiceDetailsProvided = hasPanCard && Boolean(user?.invoice_city_id) && Boolean(user?.state_id) && Boolean(user?.pincode) && Boolean(user?.address);

        return {
            hasPanCard,
            hasPanVerified,
            hasAadharCardVerified,
            hasGstNumber,
            hasGstVerified,
            // hasTaxInvoiceDetailsProvided
        };

    }, [user]);

    // console.log("User Status: ", JSON.stringify(status, null, 2));

    return status;
}